import { render, staticRenderFns } from "./GuidelineChat.vue?vue&type=template&id=7b4d614c&scoped=true&"
import script from "./GuidelineChat.vue?vue&type=script&lang=ts&"
export * from "./GuidelineChat.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineChat.vue?vue&type=style&index=0&id=7b4d614c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d614c",
  null
  
)

export default component.exports